import { combineReducers } from 'redux'

import auth from './authentication'
import sidebar from './sidebar'

export default combineReducers({
    auth,
    sidebar,
})